import { ICorrelation } from '@app/api/interfaces/correlation.interface';
import { IEvent } from '@app/api/interfaces/event.interface';
import { LdTabs } from '@app/main/leak-detection/enums/ld-tabs';
import {
  LdActionPlace,
  LdActionType,
  LdCoordinatorActionShowInStreetView,
  LdCoordinatorActionZoomToFitItem,
} from '@app/main/leak-detection/services/leak-detection-coordinator/leak-detection-coordinator.actions';
import { IMapBounds } from '@app/main/main-content/map/interfaces/map-bounds.interface';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export interface ILdCoordinatorState {
  selectedLoggers: ILdLogger[];
  selectedCorrelations: ICorrelation[];
  selectedEvents: IEvent[];
  activeTab: LdTabs;
  scrollToId: string | null;
  lastActionType: LdActionType | null;
  lastActionPlace: LdActionPlace | null;
  visibleCellsIds: string[] | null;
  selectedCellsIds: string[];
  cellIdSelectionFromMap: boolean;
  actionZoomToFitItem: LdCoordinatorActionZoomToFitItem | null;
  actionShowInStreetView: LdCoordinatorActionShowInStreetView | null;
  mapBounds: IMapBounds | null;
}

export const initialLdCoordinatorState: ILdCoordinatorState = {
  selectedLoggers: [],
  selectedCorrelations: [],
  selectedEvents: [],
  activeTab: LdTabs.Kpi,
  scrollToId: null,
  lastActionType: null,
  lastActionPlace: null,
  visibleCellsIds: null,
  selectedCellsIds: [],
  cellIdSelectionFromMap: false,
  actionZoomToFitItem: null,
  actionShowInStreetView: null,
  mapBounds: null,
};
